<template>
  <div class="etx-container Container overflow-visible" :class="paragraphClassList">
    <div class="etx-center Center">

      <div class="etx-card Card CardDisruptor bg-secondary" :class="entranceClassList" data-angle-position="top-right" data-angle-color="primary">
        <div class="etx-card__item Card__item ph-150 pv-150 mob-m:ph-200 mob-m:pv-200 tab-l:ph-0 tab-l:pv-0">

          <div class="etx-spacer Spacer h-0 tab-l:h-75"></div>

          <div class="etx-flex Flex gv-200 tab-s:gv-0">

            <div class="etx-flex__item Flex__item tab-s:c-6 tab-l:c-4 tab-l:ml-1">

              <div class="etx-text Text" v-if="heading || headingSubline || text">
                <h2 v-if="heading && headingType == 'h2'" class="font-color-primary" :class="headingStyle !== 'standard' ? headingStyle : ''">{{ heading }}</h2>
                <h3 v-if="heading && headingType == 'h3'" class="font-color-primary" :class="headingStyle !== 'standard' ? headingStyle : ''">{{ heading }}</h3>
                <h4 v-if="heading && headingType == 'h4'" class="font-color-primary" :class="headingStyle !== 'standard' ? headingStyle : ''">{{ heading }}</h4>
                <p v-if="headingSubline" class="font-h2 alt">{{ headingSubline }}</p>
                <HelperHtmlRenderer :htmlContent="text" />
              </div>

              <BlokkliProxyMode :isEditing="isEditing" fieldName="field_link_elements_rev" :elements="buttons" />
              <div v-if="buttons?.length > 0" class="etx-button-list ButtonList">
                <Button v-for="button in buttons"
                  :type="button?.type"
                  :targetBlank="button?.targetBlank"
                  :href="button?.link?.domainUri?.path || button?.link?.uri?.path"
                  :label="button?.label"
                  :alt="button?.alt"
                />
              </div>
            </div>

            <div v-if="downloads?.length > 0" class="etx-flex__item Flex__item tab-s:c-5 tab-s:ml-1">

              <div v-for="download in downloads" class="etx-card Card CardDisruptor__download has-link">

                <a class="etx-card__link Card__link" :href="download.url.path" :title="download.title" target="_blank"></a>

                <div class="etx-card__item Card__item ph-0 pv-0">

                  <div class="etx-flex Flex c-auto nowrap gh-50">

                    <div class="etx-flex__item Flex__item shrink-0">

                      <div class="Icon medium">
                        <i class="fa-sharp fa-light fa-arrow-down-to-bracket"></i>
                      </div>

                    </div>

                    <div class="etx-flex__item Flex__item grow-1">

                      <div class="etx-text Text">
                        <p class="font-weight-bold">{{ download.title }}</p>
                        <p v-if="download.description" class="font-size-small font-color-medium">{{ download.description }}</p>
                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

          <div class="etx-spacer Spacer h-0 tab-l:h-75"></div>

        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
  heading?: string
  headingType: string
  headingStyle: string
  headingSubline?: string
  text?: string
  buttons: Array<any>
  downloads: Array<any>
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'downloads_2_col_titlebar',
  globalOptions: ['spacingTop', 'spacingBottom'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

</script>
